import { appTypeKey, sPkg } from '@/constants'
import { initSentry } from 'web-utils/sentry'
import { isInNativeApp, deviceInfo } from 'web-utils/device'
import { getAppType, isRealTgEnv } from './index'

export default function setupSentry(app) {
  // 客户端关闭广告回调，先预定义，防止sentry告警
  window.closeAdvertise = () => {
    console.log('app close advertise')
  }
  const env = import.meta.env.MODE
  const isPro = env === 'pro'
  if (!isPro) {
    return
  }
  const customTags = {
    appType: sessionStorage.getItem(appTypeKey) || getAppType(),
    pkg: sPkg,
    inTg: isRealTgEnv(),
    inTaurus: isInNativeApp()
  }
  if (isInNativeApp()) {
    customTags.taurusAppVersion = deviceInfo()?.appVersion
  }
  initSentry({
    isVue3: true,
    vueInstance: app,
    env,
    dsn: 'https://6db7dc1df5aee18eb72a36909af9e540@sentry.taer.xyz/7',
    customTags,
    // eslint-disable-next-line no-undef
    release: process.env.VITE_SENTRY_RELEASE
  })
  window.onActivityResume = () => {}
}
